var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 48C88 25.92 70.08 8 48 8C25.92 8 8 25.92 8 48C8 70.08 25.92 88 48 88C70.08 88 88 70.08 88 48ZM34 62L20 48L34 34V44H50V52H34V62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "payment-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 31.3579C53 30.6009 53.3292 29.8117 53.9153 29.2764C53.04 29.5682 54.5013 28.7411 53.9153 29.2764C60.8617 26.9605 74.875 28.5037 74.875 28.5037C75.7038 28.5037 76.4987 28.8044 77.0847 29.3397C77.6708 29.875 78 30.6009 78 31.3579C78 32.1149 77.6708 32.8409 77.0847 33.3761C76.4987 33.9114 75.7038 34.2121 74.875 34.2121H70.0781C70.6442 35.106 71.0742 36.0662 71.3562 37.0663H74.875C75.7038 37.0663 76.4987 37.367 77.0847 37.9022C77.6708 38.4375 78 39.1635 78 39.9204C78 40.6774 77.6708 41.4034 77.0847 41.9386C76.4987 42.4739 75.7038 42.7746 74.875 42.7746H71.3562C70.7707 44.8389 69.5648 46.7124 67.8747 48.1837C66.1847 49.6549 64.0778 50.6651 61.7922 51.1003L71.225 64.0254C71.4611 64.3371 71.627 64.6886 71.7128 65.0594C71.7986 65.4302 71.8027 65.8129 71.7248 66.1852C71.6469 66.5575 71.4886 66.9119 71.2592 67.2277C71.0297 67.5435 70.7337 67.8144 70.3884 68.0246C70.0431 68.2348 69.6554 68.3801 69.2479 68.4519C68.8405 68.5238 68.4214 68.5209 68.0152 68.4432C67.6091 68.3656 67.2239 68.2149 66.8822 67.9998C66.5405 67.7847 66.2491 67.5097 66.025 67.1907L56.125 55.0037C55.8114 54.5739 53.0314 49.1363 53.0042 48.6204C52.977 48.1045 53.3704 47.1361 53.3704 47.1361C53.3704 47.1361 54.0344 46.3 54.5195 46.0346C55.0046 45.7691 55.5595 45.6289 56.125 45.6288H59.25C61.5625 45.6288 63.5828 44.4814 64.6641 42.7746H56.125C55.2962 42.7746 54.5013 42.4739 53.9153 41.9386C53.3292 41.4034 53 40.6774 53 39.9204C53 39.1635 53.3292 38.4375 53.9153 37.9022C54.5013 37.367 55.2962 37.0663 56.125 37.0663H64.6641C64.1156 36.1981 63.3265 35.4772 62.376 34.9762C61.4256 34.4751 60.3474 34.2116 59.25 34.2121H56.125C55.2962 34.2121 54.5013 33.9114 53.9153 33.3761C53.3292 32.8409 53 32.1149 53 31.3579Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.1b7c198724f48a429acf926d317b3ca0.svg";
export { ForwardRef as ReactComponent };